import { constants } from "~/constants";
import { HomeScreen } from "~/features/live-chat-experiment/HomeScreen";

function HardRedirect({ href }: { href: string }) {
  window.location.href = href;
  return null;
}

export default function IndexEN() {
  if (intl.shouldRedirect) {
    return (
      <HardRedirect
        href={
          intl.locale === constants.DEFAULT_LANGUAGE ? "/" : `/${intl.locale}`
        }
      />
    );
  }

  return <HomeScreen />;
}
